import { gql } from '__generated__'

export const GetCompaniesByName = gql(/* GraphQL */ `
    query GetCompaniesByName($name: String!, $limit: Int, $page: Int) {
        companiesByName(name: $name, limit: $limit, page: $page) {
            data {
                id
                value
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)

export const GetTopTierCompaniesByName = gql(/* GraphQL */ `
    query GetTopTierCompaniesByName($name: String!, $limit: Int, $page: Int) {
        topTierCompanies(name: $name, limit: $limit, page: $page) {
            data {
                id
                value
            }
            pageInfo {
                itemTotal
                pageNumber
                pageTotal
            }
        }
    }
`)
